import {
  faFacebook,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer
        style={{
          background: "#4a90e2",
          padding: "15px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "white",
          borderTop: "1px solid #dee2e6",
          flexWrap: "wrap",
          minHeight: "60px"
        }}
      >
        {/* Copyright Section */}
        <p style={{ margin: 0, fontSize: "0.9rem", opacity: "0.9" }}>
          © 2025 - {new Date().getFullYear()} Iconic Greenland. All Rights
          Reserved &nbsp;&nbsp; | &nbsp;&nbsp;Designed & Developed by Iconic Soft Ltd.
        </p>

        {/* Social Icons Section */}
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <Link to="#" className="text-dark">
            <FontAwesomeIcon
              icon={faFacebook}
              size="lg"
              style={{ color: "white", opacity: "0.8" }}
            />
          </Link>
          <Link to="#" className="text-dark">
            <FontAwesomeIcon
              icon={faTwitter}
              size="lg"
              style={{ color: "white", opacity: "0.8" }}
            />
          </Link>
          <Link to="#" className="text-dark">
            <FontAwesomeIcon
              icon={faYoutube}
              size="lg"
              style={{ color: "white", opacity: "0.8" }}
            />
          </Link>
        </div>
      </footer>
    </>
  );
};

export default Footer;